import React, { useState } from 'react'
import Navbar from '../Navbar'
import '../styles/Styles.css'
import style from '../styles/cloud-vase.module.css'

import img1 from './cloud-vase/img1.jpg'
import img2 from './cloud-vase/img2.jpg'
import dscf4753 from './cloud-vase/DSCF4753.jpg'

const images = [dscf4753, img1, img2]

const CloudVase = () => {
    const [selectedImage, setSelectedImage] = useState(0)
    const [hoveredImage, setHoveredImage] = useState(null)
    const [shouldAnimateImage, setShouldAnimateImage] = useState(false)

    return (
        <section className={`ideas ${style.cloudVaseSection}`}>
            <Navbar/>
            <div className={style.contentWrapper}>
                <div className={style.container}>
                    <div className={style.layout}>
                        {/* Left column - images */}
                        <div className={style.imageColumn}>
                            <div className={style.thumbnailGrid}>
                                {images.map((img, idx) => (
                                    <div
                                        key={idx}
                                        className={`${style.thumbnailWrapper} ${selectedImage === idx ? style.thumbnailActive : ''} ${(selectedImage === idx || hoveredImage === idx) ? style.thumbnailDisplayed : ''}`}
                                        onClick={() => {
                                            if (idx !== selectedImage) {
                                                setShouldAnimateImage(true)
                                                setSelectedImage(idx)
                                            }
                                        }}
                                        onMouseEnter={() => setHoveredImage(idx)}
                                        onMouseLeave={() => setHoveredImage(null)}
                                    >
                                        <img
                                            src={img}
                                            alt={`Cloud Vase view ${idx + 1}`}
                                            className={style.thumbnail}
                                        />
                                        <div className={style.thumbnailOverlay} />
                                    </div>
                                ))}
                            </div>
                            <div className={style.mainImageWrapper}>
                                {selectedImage !== null ? (
                                    <img
                                        key={selectedImage}
                                        src={images[selectedImage]}
                                        alt="Cloud Vase"
                                        className={`${style.mainImage} ${shouldAnimateImage ? style.mainImageAnimated : ''}`}
                                    />
                                ) : (
                                    <div className={style.mainImagePlaceholder} />
                                )}
                            </div>
                        </div>

                        {/* Right column - text */}
                        <div className={style.textColumn}>
                            <h1 className={style.title}>Cloud Vase</h1>
                            <p className={style.body}>
                            Designed for Allison. Her bubbly, cheerful personality reminds me of summer clouds!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CloudVase
